import { render, staticRenderFns } from "./BaseTextareaGroup.vue?vue&type=template&id=66633b55&"
import script from "./BaseTextareaGroup.vue?vue&type=script&lang=js&"
export * from "./BaseTextareaGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports